import { Skeleton, Box } from '@kiwicom/orbit-components';
import { Media } from '@kiwicom/account-global-contexts';
import { useIntl } from 'react-intl';

const UserBarPlaceholder = (): JSX.Element => {
  const intl = useIntl();
  return (
    <Box
      background="whiteNormal"
      width="100%"
      padding={{ top: '800', bottom: '800' }}
      data-test="UserBar"
    >
      <Box maxWidth="960px" className="m-auto">
        <Media lessThan="desktop">
          <Skeleton
            height={60}
            dataTest="Userbar-placeholder"
            title={intl.formatMessage({
              id: 'common.loading',
              defaultMessage: 'Loading',
            })}
          >
            <rect x="25" ry="50" rx="50" height="60" width="60" />
            <rect x="100" y="5" rx="4" ry="3" height="28" width="180" />
            <rect x="100" y="45" rx="4" ry="3" height="16" width="140" />
          </Skeleton>
        </Media>
        <Media greaterThanOrEqual="desktop">
          <Skeleton
            height={60}
            dataTest="Userbar-placeholder"
            title={intl.formatMessage({
              id: 'common.loading',
              defaultMessage: 'Loading',
            })}
          >
            <rect x="25" ry="50" rx="50" height="60" width="60" />
            <rect x="125" y="5" rx="4" ry="3" height="28" width="180" />
            <rect x="125" y="45" rx="4" ry="3" height="16" width="140" />
          </Skeleton>
        </Media>
      </Box>
    </Box>
  );
};

export default UserBarPlaceholder;
